import type { SiteDetailsApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const fetchSiteDetails = async (siteId: string) => {
  const response = await XHRAuthorizedClient.get<SiteDetailsApiResponse>(
    ENDPOINTS.dashboard.siteDetails(siteId)
  );

  return response.data.data;
};
